<template>
  <div id="sidebar-plot-item">
    <vx-card class="mt-4">
      <vs-row vs-type="flex" vs-justify="center" vs-align="center">
        <vs-col vs-w="2">
          <img class="icon-size" :src="img">
        </vs-col>
        <vs-col vs-w="7">
          <div class="aisea-text-14-400-white">{{ plot.title }}</div>
          <div class="plot-range-datetime">
            <vs-divider class="mt-1 mb-1" :color="AISEA_COLOR.GRAY"><span class="aisea-text-12-400-white">表示期限</span>
            </vs-divider>
            <vs-row class="mt-1 aisea-text-12-400-white" vs-type="flex" vs-justify="center" vs-align="center">
              <vs-col vs-w="3">開始</vs-col>
              <vs-col vs-w="9">
                <span v-if="plot.detail.start_date">{{ plot.detail.start_date | toYMDHM }}</span>
                <span v-else>-</span>
              </vs-col>
            </vs-row>
            <vs-row class="mt-1 aisea-text-12-400-white" vs-type="flex" vs-justify="center" vs-align="center">
              <vs-col vs-w="3">終了</vs-col>
              <vs-col vs-w="9">
                <span v-if="plot.detail.end_date">{{ plot.detail.end_date | toYMDHM }}</span>
                <span v-else>-</span>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
        <vs-col vs-w="3" vs-justify="flex-end" vs-type="flex">
          <vs-button
            class="mr-2"
            size="small"
            :color="btnStyle.color"
            type="filled"
            icon-pack="feather"
            icon="icon-map-pin"
            @click="jumpTo"
          ></vs-button>
          <vs-button
            size="small"
            :color="btnStyle.color"
            type="filled"
            icon-pack="feather"
            icon="icon-info"
            @click="showDetails"
          ></vs-button>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import * as turf from '@turf/turf';
import {
  PLOT_CHILD_CATEGORY
} from "@/config/const";

// Mixins
import {ColorMixin} from "@/mixins";

export default {
  mixins: [ColorMixin],
  props: {
    plot: Object
  },
  data() {
    return {
      btnStyle: {
        color: "#549BD4"
      },
    };
  },
  computed: {
    img() {
      return require("@/assets/images/plot/" + PLOT_CHILD_CATEGORY.properties[this.plot.child_category.id].img + ".png");
    },
    plotIcon() {
      return require("@/assets/images/icons/sideber-menu/plot.svg");
    },
  },
  methods: {
    jumpTo() {
      if (this.plot.plot_points) {
        let collections = this.plot.plot_points.map(e => {
          return turf.point([e.longitude, e.latitude])
        });
        let features = turf.featureCollection(collections);
        let center = turf.center(features);
        let coordinates = {
          center: center.geometry.coordinates
        };
        this.$emit("jumpTo", coordinates);
      } else {
        this.$vs.notify({
          title: "位置情報がありません",
          color: "warning",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      }
    },
    showDetails() {
      const fromLiveMap = this.$route.name === "enterprise-live-map";
      this.$router.push({
        name: "enterprise-plot-edit",
        params: {id: this.plot.id, fromLiveMap}
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

#sidebar-plot-item {
  .icon-size {
    height: 2rem;
  }

  .plot-range-datetime {
    color: gray;
    font-size: 0.8rem;
  }

  .vx-card {
    background: $aisea-blue-gray;
  }
}
</style>
